// 24 Oct 2026 (Nas, page weight): moved out of snippets/adore-fx-site.liquid so the browser can cache it. Code unchanged.
  /* 12 Oct 2026 (Worker SITE): small DOM fixes. Every step is safe to run twice. */
  (function(){
    var INK='#1D1A17', MUTED='#57504A';
    /* (3) autocomplete on the site's own contact forms, including the price beat pop-up (email was autocomplete="off") */
    function ac(root){
      [].forEach.call((root||document).querySelectorAll('input[name^="contact["],textarea[name^="contact["]'),function(i){
        if(i.closest('[class*="klaviyo"],[class*="kl-private"]'))return;
        var n=(i.name||'').toLowerCase(), cur=(i.getAttribute('autocomplete')||'').toLowerCase(), want='';
        if(n==='contact[name]')want='name';
        else if(/contact\[(phone|mobile)\]/.test(n)||i.type==='tel')want='tel';
        else if(n==='contact[email]'||i.type==='email')want='email';
        else if(/suburb|postcode/.test(n))want='address-level2';
        if(want&&(cur===''||cur==='off'||cur==='on'))i.setAttribute('autocomplete',want);
      });
    }
    /* (6) account icon needs an accessible name */
    function acct(){
      [].forEach.call(document.querySelectorAll('a[href^="/account/login"]'),function(a){
        if(a.getAttribute('href').indexOf('#')>-1)return;
        if(!a.getAttribute('aria-label')&&!a.textContent.trim())a.setAttribute('aria-label','Account');
      });
    }
    /* (4) hide "0 selected" in the filter headers */
    function zero(){
      [].forEach.call(document.querySelectorAll('.collection-filters__selected'),function(s){
        s.classList.toggle('adore-fx-zero',/^\s*0\b/.test(s.textContent));
      });
    }
    /* (1) free measure page: "Text us" next to each Call button, and a sweep for any leftover off-system text colours */
    function lp(){
      var root=document.querySelector('.adore-lp'); if(!root)return;
      [].forEach.call(root.querySelectorAll('.lp-cta a.btn--ghost[href^="tel:"]'),function(c){
        var n=c.nextElementSibling;
        if(n&&n.classList.contains('adore-fx-sms'))return;
        var t=document.createElement('a');
        t.href='sms:0483939938'; t.className='btn btn--ghost adore-fx-sms'; t.textContent='Text us';
        t.setAttribute('aria-label','Text us on 0483 939 938');
        c.insertAdjacentElement('afterend',t);
      });
      var MAP={'rgb(21, 21, 21)':INK,'rgb(28, 28, 28)':INK,'rgb(42, 42, 42)':INK,'rgb(51, 51, 51)':MUTED,'rgb(74, 74, 74)':MUTED,'rgb(232, 164, 0)':INK,'rgb(138, 18, 25)':INK};
      [].forEach.call(root.querySelectorAll('*'),function(e){
        if(e.closest('svg'))return;
        var c=getComputedStyle(e).color; if(MAP[c])e.style.setProperty('color',MAP[c],'important');
      });
    }
    function run(){ac();acct();zero();lp();}
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
    window.addEventListener('load',run);
    /* filters and pop-ups re-render after load: re-run the cheap steps */
    var t=null;
    try{new MutationObserver(function(){clearTimeout(t);t=setTimeout(function(){ac();acct();zero();},150);}).observe(document.documentElement,{childList:true,subtree:true});}catch(e){}
  })();
